<template>
  <div :class="classes">
    <div class="message__content">
      <slot>
        <div
          v-if="isHtml"
          v-html="text"
        />
        <div v-else>
          <div
            v-if="title"
            class="message__title"
          >
            {{ title }}
          </div>
          <div class="message__text">{{ text }}</div>
        </div>
      </slot>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

// props
const props = defineProps({
  text: {
    type: String,
    default: '',
  },

  title: {
    type: String,
    default: '',
  },

  severity: {
    type: String,
    default: 'info',
  },

  isHtml: {
    type: Boolean,
    default: false,
  },
})

// Computed
const classes = computed(() => {
  return ['message', `message--${props.severity}`]
})
</script>

<style scoped>
.message {
  font-family: Open Sans;
  padding: 15px;
  position: relative;
  cursor: default;

  &__content,
  &__title,
  &__text {
    font-size: 15px !important;
    line-height: 20px !important;
  }

  &__title {
    font-family: Open Sans, sans-serif;
    font-weight: bold;
  }

  &--success {
    background-color: var(--c-primary-color-2);
    color: var(--c-primary-neutral-3);
  }

  &--info {
    background-color: var(--c-primary-neutral-2);
    color: var(--c-primary-neutral-1);
  }

  &--info-white {
    background-color: var(--c-primary-neutral-3);
    color: var(--c-primary-neutral-1);
  }

  &--info-dark {
    background-color: var(--c-secondary-neutral-3);
    color: var(--c-primary-neutral-1);
  }

  &--info-green-lighten {
    background-color: var(--c-primary-color-2-d);
    color: var(--c-primary-neutral-1);
  }

  &--warning {
    background-color: var(--c-secondary-color-4);
    color: var(--c-primary-neutral-1);
  }

  &--error {
    background-color: var(--c-secondary-color-1);
    color: var(--c-primary-neutral-3);
  }

  &__action {
    display: none;
    position: absolute;
    top: 5px;
    right: 5px;
    cursor: pointer;
  }
}

@media (--md) {
  .message {
    &__action {
      display: block;
    }
  }
}
</style>
